<template>
  <div class="instruction-card card-item" :class="marginClass">
    <div class="instruction-header">
      <i class="fa-solid fa-list-ol me-2 text-primary"></i>
      <span class="instruction-title">{{ title }}</span>
    </div>
    <div class="instruction-body">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="instruction-step"
      >
        <div class="instruction-step-number">{{ index + 1 }}</div>
        <div class="instruction-step-content" v-html="step"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  /** HTML 문자열 배열 (trusted static copy) */
  steps: {
    type: Array,
    required: true,
  },
  marginClass: {
    type: String,
    default: 'mb-2',
  },
});
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.instruction-step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.instruction-step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}

.instruction-step-content :deep(strong) {
  color: #0d6efd;
  font-weight: 600;
}
</style>
